import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import BlogTeaser from "@/components/landing/BlogTeaser";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

const HOME_JSONLD = [
  {
    "@type": "ProfessionalService",
    name: "Florida Business & Relocation",
    description:
      "Relocation & Unternehmensberatung für Deutsche und Schweizer in Florida – Unternehmensgründung, Immigration, Relocation und laufende Begleitung auf Deutsch.",
    telephone: "+1-305-529-4140",
    address: {
      "@type": "PostalAddress",
      streetAddress: "7255 Bee Ridge Rd",
      addressLocality: "Sarasota",
      addressRegion: "FL",
      addressCountry: "US",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1-305-529-4140",
      contactType: "customer service",
      availableLanguage: ["de"],
    },
    areaServed: { "@type": "State", name: "Florida" },
    knowsLanguage: ["de"],
  },
];

export default function Landing() {
  return (
    <>
      <Seo jsonLd={HOME_JSONLD} />
      <Header />
      <main>
        <Hero />
        <BlogTeaser />
      </main>
      <Footer />
    </>
  );
}
